import { render, staticRenderFns } from "./MyConsultant.vue?vue&type=template&id=35fe4528&scoped=true&"
import script from "./MyConsultant.vue?vue&type=script&lang=js&"
export * from "./MyConsultant.vue?vue&type=script&lang=js&"
import style0 from "./MyConsultant.vue?vue&type=style&index=0&id=35fe4528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe4528",
  null
  
)

export default component.exports